import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../Config/Constant";

const initialState = {
    user: null,
    token: localStorage.getItem("token") || "",
    role: localStorage.getItem("role") || "",
    companyPin: localStorage.getItem("companyPin") || "",
    companyId: localStorage.getItem("companyId") || null,
    companyName: localStorage.getItem("companyName") || "",
    loading: false,
    error: null,
};

// Login Thunk
export const userLogin = createAsyncThunk(
    "auth/userLogin",
    async ({ body, type }, { rejectWithValue }) => {
        try {

            // 👇 dynamic URL
            const url =
                type === "superadmin"
                    ? `${API_URL}superadmin/login`
                    : `${API_URL}login`;

            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            const data = await res.json();

            if (!res.ok) {
                return rejectWithValue(data?.message || "Login failed");
            }

            return data;

        } catch (error) {
            return rejectWithValue("Server error");
        }
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.user = null;
            state.token = "";
            state.role = "";
            state.error = null;

            localStorage.removeItem("token");
            localStorage.removeItem("role");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(userLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(userLogin.fulfilled, (state, action) => {
                state.loading = false;

                // Set user info
                state.user = {
                    firstName: action.payload.firstName,
                    lastName: action.payload.lastName,
                    userName: action.payload.userName,
                };

                // Set token
                state.token = action.payload.token;

                // Set role
                state.role = action.payload.role;
                state.companyId = action.payload.company_id;
                state.companyPin = action.payload.company_pin;
                state.companyName = action.payload.companyName;

                // Save to localStorage
                localStorage.setItem("token", state.token);
                localStorage.setItem("role", state.role);
                localStorage.setItem("companyPin", state.companyPin);
                localStorage.setItem("companyId", state.companyId);
                localStorage.setItem("companyName", state.companyName);

                console.log("Redux Role Set:", state.role);
            })
            .addCase(userLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Login failed";
            });
    },
});

export const { logout } = authSlice.actions;
export const authReducer = authSlice.reducer;
